import { Component, Input } from '@angular/core';

@Component({
  selector: 'papi-card',
  templateUrl: './card.component.html',
})
export class CardComponent {
  @Input() classesList: string = '';

}
